import React, { ReactElement } from "react";
import { Marker, Tooltip, useMap } from "react-leaflet";
import { customMapMarkerProps } from "./mapTypes";
import L from "leaflet";
import mapMarker from "../../assets/img/mapMarker.svg";
import mapMarkerHighlight from "../../assets/img/mapMarkerHighlight.svg";

const CustomMarkerIcon = new L.Icon({
  iconUrl: mapMarker,
  iconRetinaUrl: mapMarker,
  iconSize: new L.Point(30, 45),
});

const CustomMarkerHighlightIcon = new L.Icon({
  iconUrl: mapMarkerHighlight,
  iconRetinaUrl: mapMarkerHighlight,
  iconSize: new L.Point(30, 45),
});

export default function CustomMapMarkers(props: customMapMarkerProps): ReactElement {
  const mapref = useMap();
  if (props.selectedMarker !== "") {
    const selectedMarkerObj = props.markers.find((e) => e.name === props.selectedMarker);
    selectedMarkerObj && mapref.flyTo([selectedMarkerObj?.breitengrad, selectedMarkerObj?.laengengrad], 16, {});
  } else {
    mapref.fitBounds(props.bounds);
  }

  return (
    <div>
      {props.markers.map((x, key) => (
        <Marker
          position={[x.breitengrad, x.laengengrad]}
          key={key}
          icon={
            x.name === props.selectedMarker
              ? CustomMarkerHighlightIcon
              : CustomMarkerIcon
          }
          zIndexOffset={x.name === props.selectedMarker ? 9 : 1}
        >
          <Tooltip>{x.name}</Tooltip>
        </Marker>
      ))}
    </div>
  );
}
